import React, { useEffect } from "react";
import { default as Text } from "./Text";

const ImgTextRow = ({ content }) => {
  useEffect(() => {
    let time;
    if (document.getElementById("fading-volume-image")) {
      document
        .getElementById("fading-volume-image")
        .classList.add("img-fade-out");
      document.getElementById("fading-volume-image").style.opacity = 1;
      time = setTimeout(() => {
        document
          .getElementById("fading-volume-image")
          .classList.remove("img-fade-out");
        document.getElementById("fading-volume-image").style.opacity = 0;
      }, 500);
      return () => {
        clearTimeout(time);
      };
    }
  }, [content.prev_src]);

  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        transformOrigin: "left center",
        display: "flex",
        justifyContent: "flex-start",
      }}
    >
      <div
        style={{
          display: "flex",
          height: "100%",
          width: "40%",
          position: "relative",
          marginLeft: "3%",
        }}
      >
        <div style={{}}>
          <img
            src={content.src}
            width="100%"
            style={{
              margin: "0",
              position: "absolute",
              left: "0px",
              top: "0px",
              zIndex: "10",
            }}
          />

          {content.prev_src ? (
            <img
              id="fading-volume-image"
              src={content.prev_src}
              width="100%"
              style={{
                margin: "0",
                position: "absolute",
                left: "0px",
                top: "0px",
                zIndex: "11",
              }}
            />
          ) : null}
        </div>
      </div>
      {content.text ? (
        <div style={{ width: "40%", margin: "0 0 0 20px", flex: 1 }}>
          {content.text.content.map((obj, i) => {
            return (
              <p
                className={obj.type === "title" ? "body-title" : "body-text"}
                style={{
                  fontFamily: obj.font ? obj.font : "LG_Smart_Regular",
                  fontSize: obj.font_size,
                  color: obj.font_color,
                  margin: "0 0 0 0",
                  lineHeight: obj.line_height ? obj.line_height : null,
                }}
                dangerouslySetInnerHTML={{
                  __html: obj.text,
                }}
              ></p>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default ImgTextRow;
